let createNanoEvents = () => ({
  events: {},
  emit(event) {
    for (var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
      args[_key - 1] = arguments[_key];
    }
    ;
    (this.events[event] || []).forEach(i => i(...args));
  },
  on(event, cb) {
    ;
    (this.events[event] = this.events[event] || []).push(cb);
    return () => this.events[event] = (this.events[event] || []).filter(i => i !== cb);
  }
});
export { createNanoEvents };